import React from 'react';
import {
  FDAlert, FDBox, FDStack, PrimaryActionButton,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { injectStripe } from 'react-stripe-elements';
import PropTypes from 'prop-types';
import { useSubmitHandler } from 'Views/Page/Content/Templates/WizardTemplates/Buy/useSubmitHandler';
import { dataAttrs } from 'Helpers/Testing';
import ErrorList from 'Components/UI/ErrorList';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  EstatePlanningC2BWrapper,
} from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/components/EstatePlanningC2BWrapper';
import FirstYearAmountPicker from './FirstYearAmountPicker/FirstYearAmountPicker';

import 'Components/Modals/PaymentModal/index.css';

const EstatePlanningBuyPaymentStepLayout = ({ stripe }) => {
  const {
    saving,
    resource,
  } = useMetaLayoutContext();
  const {
    onSubmit,
    metaErrors,
    stripeError,
    loading,
  } = useSubmitHandler({ stripe });
  const isMobile = useMobileLayout();

  let error = null;
  if (stripeError) {
    error = (
      <FDAlert
        title="Error processing credit card"
        description={stripeError}
        status="error"
        {...dataAttrs('stripe error')}
      />
    );
  } else if (metaErrors.length) {
    error = <ErrorList errors={metaErrors} title="Error" />;
  }

  return (
    <div className={'buyWizard'}> {/* This div is here to style the Stripe inputs. TODO: Move this logic to a common place. not buyWizard */}
      <EstatePlanningC2BWrapper>
        <FDBox paddingY={2}>
          <FDStack direction={'column'}>
            <MetaControlField attr={'dueTodayText'} />
            <FirstYearAmountPicker resource={resource} />
            <MetaControlField attr={'firstYearText'} />
          </FDStack>
        </FDBox>
        <FDBox flexGrow={1}>
          <MetaControlField attr="useDefaultCreditCard" />
          <FDStack direction="column" spacing={2}>
            <MetaControlField attr="stripeToken" />
            {!isMobile ? error : null}
          </FDStack>
        </FDBox>
        <MetaControlField attr={'footer'} />
        <FDBox paddingY={2}>
          <FDStack direction={'row'} justifyContent={'center'}>
            <PrimaryActionButton
              size={'lg'}
              label={'Make Payment'}
              loading={loading || saving}
              onClick={async () => onSubmit()}
            />
          </FDStack>
        </FDBox>
      </EstatePlanningC2BWrapper>
    </div>
  );
};

EstatePlanningBuyPaymentStepLayout.defaultProps = {
};

EstatePlanningBuyPaymentStepLayout.propTypes = {
  stripe: PropTypes.object.isRequired,
};

export default injectStripe(EstatePlanningBuyPaymentStepLayout);
